export interface ComposeContext {
  contactId?: number;
  accountId?: number;
  returnTo?: string;
  invalid: boolean;
}

const parsePositiveId = (value: string | null): number | undefined => {
  if (value === null || !/^[1-9]\d*$/.test(value)) return undefined;

  const id = Number(value);
  return Number.isSafeInteger(id) ? id : undefined;
};

export const isSafeInternalPath = (value: unknown): value is string => {
  return typeof value === 'string' && safeInternalRedirect(value) != null;
};

export const parseComposeContext = (search: string): ComposeContext => {
  const params = new URLSearchParams(search);
  const rawContactId = params.get('contactId');
  const rawAccountId = params.get('accountId');
  const contactId = parsePositiveId(rawContactId);
  const accountId = parsePositiveId(rawAccountId);
  const returnTo = params.get('returnTo');
  const invalid =
    (rawContactId !== null && contactId === undefined) ||
    (rawAccountId !== null && accountId === undefined) ||
    (contactId !== undefined && accountId !== undefined);

  return {
    contactId,
    accountId,
    returnTo: isSafeInternalPath(returnTo) ? returnTo : undefined,
    invalid,
  };
};

export const resolveComposeReturnPath = ({
  guidedReturnTo,
  stateReturnTo,
  queryReturnTo,
  fallback,
}: {
  guidedReturnTo?: string;
  stateReturnTo?: unknown;
  queryReturnTo?: string;
  fallback: string;
}): string =>
  guidedReturnTo ||
  (isSafeInternalPath(stateReturnTo) ? stateReturnTo : undefined) ||
  queryReturnTo ||
  fallback;

export const buildComposePath = ({
  contactId,
  accountId,
  returnTo,
}: Omit<ComposeContext, 'invalid'>): string => {
  const params = new URLSearchParams();
  if (contactId) params.set('contactId', String(contactId));
  if (accountId) params.set('accountId', String(accountId));
  if (isSafeInternalPath(returnTo)) params.set('returnTo', returnTo);

  const query = params.toString();
  return `/messages/new${query ? `?${query}` : ''}`;
};
import { safeInternalRedirect } from 'modules/profile/safeInternalRedirect';
